import { DocData, DocsLinks, DocumentName } from '@/types/legal';

export const getMappingDocs = (data: DocData[]) => {
	return data?.reduce((acc, doc) => {
		acc[DocumentName[doc.title_en]] = doc.file ?? '';
		return acc;
	}, {} as DocsLinks);
};
